<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Adding international contacts' phone numbers
                </h2>
                <h3>
                    To add an international contact's phone number
                </h3>
                <ol>
                    <li>
                        Open ToTok and go to the Chats tab.
                    </li>
                    <li>
                        Tap “+” at the top right > <strong>Add Friends</strong>.
                    </li>
                    <li>
                        Enter international number with country/region code, then tap <strong>Go</strong>.
                    </li>
                    <li> Tap <strong>ADD</strong>.</li>


                    <h6><i>Note: A country code is a numerical prefix that needs to be entered before the full national
                        phone number to
                        make a call to another country. You can search online to find the country code you need.</i>
                    </h6>

                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
